<template>
  <transition name="tips" mode="in-out">
    <div class="tips" v-show="tipShow"><svg-icon icon-class="del" /><span>{{tips}}</span></div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      tips: '手机号不能为空',
      tipShow: false
    }
  },
  methods: {
    showTips (str, time = 2) {
      this.tipShow = true
      this.tips = str
      setTimeout(() => {
        this.tipShow = false
      }, time * 1000)
    }
  }
}
</script>
<style>
/* 顶部 tips 的样式 */
.tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: #f78989;
  color: #fff!important;
  font-size: 14px;
  z-index: 5;
}
.tips img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 5px;
}
.tips svg {
  vertical-align: -3px;
  margin-right: 5px;
  font-size: 16px;
}
.tips span {
  vertical-align: 0px;
}
.tips-leave-active, .tips-enter-active {
  transition: all .5s;
}
.tips-enter {
  opacity: 0;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
.tips-leave-active {
  opacity: 0;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Tips.vue